export default "__VITE_ASSET__DChmpsIN__"